import * as React from "react";
import type { SVGProps } from "react";
const SvgLogout = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3.999 10v2.002a2 2 0 0 0 2 2h6.003a2 2 0 0 0 2-2V3.998a2 2 0 0 0-2-2H5.999a2 2 0 0 0-2 2V6"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m8 10 2-2-2-2M1.998 8H10"
    />
  </svg>
);
export default SvgLogout;
